import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de DesactivaciÃ³n / Offboarding
 * - Solicitud de eliminaciÃ³n, estado, descarga de datos
 * - Extensible para integraciÃ³n con procesos de offboarding y exportaciÃ³n de datos
 */
export default function OffboardingSection() {
    return (
        <Box>
            <Typography variant="h6">DesactivaciÃ³n / Offboarding</Typography>
            {/* TODO: Proceso de offboarding y descarga de datos */}
            <Typography variant="body2" color="text.secondary">
                Solicita la eliminaciÃ³n de tu cuenta o descarga tus datos personales.
            </Typography>
        </Box>
    );
} 